import { ajax } from '../ajax'

//1、 授课-课中签到添加
export const reqSKSignAdd = (paramets) => ajax(`/jxclassroom/jxClassroomSign/add`, paramets, 'post' )

//2、 授课-课中签到获取学生签到情况列表
export const reqSKSignStuList = (paramets) => ajax(`/jxclassroom/jxClassroomSignStu/getSignStuList`, paramets, )

//3、 授课-课中签到获取历史签到列表
export const reqSKSignList = (paramets) => ajax(`/jxclassroom/jxClassroomSign/getSignStuCountList`, paramets, )

//4、 授课-课中签到获取正在进行中的签到
export const reqSKSignOn = (paramets) => ajax(`/jxclassroom/jxClassroomSign/getSignOngoing`, paramets, )

//5、 授课-课中签到通过id获取签到详情
export const reqSKSignDetail = (paramets) => ajax(`/jxclassroom/jxClassroomSign/queryById`, paramets, )

//6、 授课-课中签到编辑
export const reqSKSignEdit = (paramets) => ajax(`/jxclassroom/jxClassroomSign/edit`, paramets, 'put')

//7、学生签到状态修改
export const reqSKSignStuEdit = (paramets) => ajax(`/jxclassroom/jxClassroomSignStu/editStuSign`, paramets, 'post')

//8、学生签到状态批量修改
export const reqSKSignStuBatchEdit = (paramets) => ajax(`/jxclassroom/jxClassroomSignStu/updateStuSignType`, paramets, 'post')
